const scriptLoader = (url, callback, scriptTag = "sortableScript") => {
  const isScriptLoaded = document.getElementById(scriptTag);
  if (isScriptLoaded) {
    callback();
    return;
  }
  const script = document.createElement("script");
  script.id = scriptTag;
  script.src = url;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
  script.onload = () => {
    if (callback) callback();
  };
};

export default scriptLoader;
